import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, Label, styled, StyledIconButtonWithLabel } from '@streem/ui-react';
import { forwardRef } from 'react';
// Similar to IconButtonWithLabel in `ui-react`, but has 2 icons (phone and caret) inside button.  As of
//    the writing of this, there are no other buttons like this.  However, if more are added, this should
//    probably be migrated to a generic component in `ui-react`.
export const BACKGROUND_COLOR = 'transparent';
export const DISABLED_COLOR = 'grey30';
export const HOVER_BACKGROUND_COLOR = 'grey10';
export const COLOR = 'blue50';
export const ButtonWithLabel = forwardRef(function CallTransferButton({ roundRightEdgeYn, disabled, style = {}, ...rest }, ref) {
    const effectiveColor = disabled ? DISABLED_COLOR : COLOR;
    return (_jsxs(StyledIconButtonWithLabel, { ref: ref, backgroundColor: BACKGROUND_COLOR, hoverBackgroundColor: HOVER_BACKGROUND_COLOR, skipHoverStyling: false, roundLeftEdgeYn: false, roundRightEdgeYn: roundRightEdgeYn, "data-testid": "call-transfer-button", disabled: disabled, style: {
            ...style,
            position: 'relative', // so call_transfer_menu can position itself relative to it
        }, ...rest, children: [_jsxs(IconWrapper, { children: [_jsx(AppIcon, { name: "CallTransferIcon", color: effectiveColor }), _jsx(AppIcon, { name: "CaretIcon", color: effectiveColor, size: "small" })] }), _jsx(Label, { "data-testid": "call-transfer-label", size: "small", color: effectiveColor, style: { whiteSpace: 'nowrap' }, children: "Transfer Call" })] }));
});
const IconWrapper = styled.span({
    display: 'inline-flex',
    gap: '.25rem',
});
//# sourceMappingURL=button_with_label.js.map